<!-- 高薪警告 -->
<template>
  <div class="high_salary">
    <div class="conent">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="company_name" label="公司名"></el-table-column>
        <el-table-column
          prop="jd_position_name"
          label="招聘职位"
        ></el-table-column>
        <el-table-column
          prop="jd_place_name"
          label="职位地点"
        ></el-table-column>
        <el-table-column prop label="职位薪资">
          <template slot-scope="scope"
            >{{ scope.row.jd_salary_min }}-{{
              scope.row.jd_salary_max
            }}
            元</template
          >
        </el-table-column>
        <el-table-column prop="jd_place_name" label="招聘规模">
          <template slot-scope="scope"
            >{{ scope.row.jd_people_max }} 人</template
          >
        </el-table-column>
        <el-table-column
          prop="jd_place_name"
          label="职位地点"
        ></el-table-column>
        <el-table-column prop="update_time" label="更新时间"></el-table-column>
        <el-table-column prop="create_time" label="创建时间"></el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="15"
          :total="total"
          hide-on-single-page
          @current-change="pageChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { require } from "@/utils/http_request.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      tableData: [],
      total: 0,
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    pageChange(page) {
      this.init(page - 1)
    },
    init(page) {
      require("post", "/hr24_index_data/v1/monitor_jd/", { page }).then(
        (res) => {
          if (!res.code) {
            this.tableData = res.data.jd_data;
            this.total = res.data.jd_count;
          }
          console.log(res)
        }
      )
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.init(0)
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>
/* //@import url(); 引入公共css类 */
.high_salary {
  width: calc(100% - 190px);
  min-height: 80vh;
  background: #fff;
  margin-top: 68px;
  margin-left: 190px;
}
.conent {
  width: 90%;
  margin: auto;
  padding: 60px 0;
}
.page {
  padding: 20px 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/user_management/high_salary.vue